import Table from 'components/Table';
import useI18n from 'i18n/useI18n';
import { useSearch } from 'providers/search';
import React, { useEffect, useState } from 'react';
import useInactive86 from 'state/inactive86';
import styled from 'styled-components';
import { compareStrings } from 'utils';
import structure from './structure';

const TableContainer = styled.div`
    flex: 1;
`;

const StatisticsTable = () => {
    const { translate } = useI18n();
    const [data] = useInactive86();
    const { search } = useSearch();
    const [list, setList] = useState([]);

    useEffect(() => {
        const newList = data.statistics.filter(
            ({ translations, why }) =>
                Object.values(translations).some(
                    ({ title, description }) => compareStrings(title ?? '', search) || compareStrings(description ?? '', search)
                )
        );
        setList(newList);
    }, [data.statistics, search]);

    return (
        <TableContainer>
            <Table
                structure={structure}
                config={{
                    translate,
                    alert,
                }}
                items={list}
            />
        </TableContainer>
    );
};

export default StatisticsTable;
